import { Icon, IconName, Intent, MaybeElement } from "@blueprintjs/core"
import React from "react"
import clsx, { extendClasses } from "utils/clsx"
import { ClassName } from "utils/custom.types"
import Badge, { BadgeProps } from "../Atoms/Badge"

type IconBadgeProps = BadgeProps & {
  size?: number
  intent?: Intent
  iconClassName?: ClassName
  animate?: boolean
  show?: boolean
  icon?: IconName | MaybeElement
}
const IconBadge = ({
  size = 22,
  iconClassName = null,
  children,
  className = null,
  intent = "success",
  animate = false,
  show = false,
  icon = "dot",
}: IconBadgeProps) => {
  return (
    <Badge
      className={className}
      showBadge={show}
      badgeComponent={
        <Icon
          size={size}
          className={clsx(
            "vt-badge-icon",
            animate && "vt-badge-icon-animate",
            ...extendClasses(iconClassName)
          )}
          intent={intent}
          icon={icon}
        />
      }
    >
      {children}
    </Badge>
  )
}

export default IconBadge
